import type { LlmGatewayProfile } from '../api/chat.client.js';

export const DEFAULT_CHAT_GATEWAY = 'openrouter' satisfies LlmGatewayProfile;

/** Routes verified for the production chat selector. Legacy conversations keep their history. */
export function isAvailableChatGateway(
  gateway: LlmGatewayProfile | undefined,
): gateway is 'openrouter' | 'opencode' {
  return gateway === 'openrouter' || gateway === 'opencode';
}
